var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UserEdit, UndoableAction } from "Server/CommandMacros";
import { GetMapObject } from "Store/firebase/mapObjects";
import { Command } from "mobx-firelink";
let DeleteMapObject = class DeleteMapObject extends Command {
    Validate() {
        let { id } = this.payload;
        //this.oldData = await GetAsync(()=>GetMapObject(id));
        this.oldData = GetMapObject(id);
    }
    GetDBUpdates() {
        let { id } = this.payload;
        let updates = {};
        // delete map-object itself
        updates[`mapObjects/${id}`] = null;
        // delete links with parents
        /*for (let {index, name: parentID} of (this.oldData.parents || {}).Props()) {
            updates[`mapObjects/${parentID}/.children/.${id}`] = null;
        }*/
        updates[`mapObjects/${this.oldData.parent}/.children/.${id}`] = null;
        return updates;
    }
};
DeleteMapObject = __decorate([
    UserEdit,
    UndoableAction()
], DeleteMapObject);
export { DeleteMapObject };
